import { CouponDto } from "@repo/api/coupon";
import { AmplifilesClient } from "./api-client";
import {
  CheckoutSessionDto,
  CreateCheckoutSessionDto,
  CustomerPortalDto,
  SyncBillingResponseDto,
} from "@repo/api/billing";

export class BillingApi {
  static async createCheckoutSession(
    teamExternalId: string,
    data: CreateCheckoutSessionDto,
  ) {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/checkout-session`,
      data,
    );
    return CheckoutSessionDto.parse(response.data);
  }

  static async generateCustomerPortalUrl(teamExternalId: string) {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/customer-portal`,
    );
    return CustomerPortalDto.parse(response.data);
  }

  static async syncBilling(teamExternalId: string) {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/sync-billing`,
    );
    return SyncBillingResponseDto.parse(response.data);
  }

  static async getCoupon(teamExternalId: string, couponCode: string) {
    const response = await AmplifilesClient.instance.get(
      `/team/${teamExternalId}/coupon/${couponCode}`,
    );
    return CouponDto.parse(response.data);
  }
}
